import { render } from "./PdfPreview.vue?vue&type=template&id=04bced5f&scoped=true"
import script from "./PdfPreview.vue?vue&type=script&lang=js"
export * from "./PdfPreview.vue?vue&type=script&lang=js"

import "./PdfPreview.vue?vue&type=style&index=0&id=04bced5f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bced5f"]])

export default __exports__